import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { TextField, Grid } from '@material-ui/core';

function FormInput({ name, label, required, onChange, defaultValue, fullWidth, multiline }) {
  const { control } = useFormContext();
  const isError = false;

  return (
    <Grid item xs={12} sm={fullWidth ? 12 : 6}>
      <Controller
        as={TextField}
        name={name}
        control={control}
        label={label}
        fullWidth        
        multiline={multiline}
        rows={4}
        required={required}
        error={isError}
        onChange={onChange}
        defaultValue={defaultValue}
      />
    </Grid>
  );
}

export default FormInput;
